// Aspect ratio presets for single-image blocks (image+text, image_only).
// 'auto' skips the aspect-ratio box entirely (natural image height).
// 'custom' lets the user type any ratio via two number inputs.
export const IMAGE_ASPECT_OPTIONS = [
  { value: '21/9', label: '21:9 Ultra-wide' },
  { value: '16/9', label: '16:9 Landscape' },
  { value: '3/2',  label: '3:2 Landscape' },
  { value: '4/3',  label: '4:3 Landscape' },
  { value: '1/1',  label: '1:1 Square' },
  { value: '4/5',  label: '4:5 Portrait' },
  { value: '3/4',  label: '3:4 Portrait' },
  { value: '2/3',  label: '2:3 Portrait' },
  { value: '9/16', label: '9:16 Tall (vertical)' },
  { value: 'auto',   label: 'Auto (original size)' },
  { value: 'custom', label: 'Custom ratio…' },
]

// Mosaic layouts for the "image_grid" block type. Each entry defines how many
// image slots it needs and a CSS Grid template (columns/rows/areas). Slot
// letters (a, b, c, d) map to block.images[0], [1], [2], [3] in order of
// first appearance in `areas` — see getGridSlotLetters() below.
export const GRID_LAYOUTS = {
  feature_left: {
    label: '⬛▪▪ Feature left',
    count: 4,
    cols: '1.15fr 1fr 1fr',
    rows: '1fr 1fr',
    areas: '"a b b" "a c d"',
  },
  feature_right: {
    label: '▪▪⬛ Feature right',
    count: 4,
    cols: '1fr 1fr 1.15fr',
    rows: '1fr 1fr',
    areas: '"b b a" "c d a"',
  },
  grid_2x2: {
    label: '▦ 2×2 grid',
    count: 4,
    cols: '1fr 1fr',
    rows: '1fr 1fr',
    areas: '"a b" "c d"',
  },
  row_3: {
    label: '▭▭▭ Row of 3',
    count: 3,
    cols: '1fr 1fr 1fr',
    rows: '1fr',
    areas: '"a b c"',
  },
  stack_2: {
    label: '▭▭ Side by side',
    count: 2,
    cols: '1fr 1fr',
    rows: '1fr',
    areas: '"a b"',
  },
}

// Returns the unique slot letters in the order they first appear in the
// areas string — this order is what image index each letter corresponds to.
export function getGridSlotLetters(areasStr) {
  const letters = []
  ;(areasStr.match(/[a-z]/g) ?? []).forEach(ch => { if (!letters.includes(ch)) letters.push(ch) })
  return letters
}